import { reaction, when } from "mobx";
import { observer } from "mobx-react";
import React from "react";
import type Tone from "tone";
import { ChatUIState, PerformanceState } from "../../common";

export interface PerformanceMusicPlayerProps {
    chatUIState: ChatUIState;
    performanceState: PerformanceState;
}

const assetUrlPath = "https://digital-dance-hall.s3.amazonaws.com/assets/choreo-performance/music";
const getPlayerUrl = (filename: string) => `${assetUrlPath}/${filename}`;

@observer
export default class PerformanceMusicPlayer extends React.PureComponent<PerformanceMusicPlayerProps> {
    private Tone?: typeof Tone;
    private scenePlayers: Map<number, Tone.Player> = new Map();
    private frame?: number;

    public async componentDidMount() {
        this.Tone = (await import("tone")).default;

        const { scene: initialScene, scenePrompts } = this.props.performanceState;

        for (const [sceneNum, promptInfo] of scenePrompts.entries()) {
            if (promptInfo.music != null) {
                const player = new this.Tone.Player(
                    getPlayerUrl(promptInfo.music),
                    initialScene === sceneNum ? this.handleInitialScenePlayerLoaded : undefined
                );
                player.volume.value = -5;
                player.connect(this.Tone.Master);
                this.scenePlayers.set(sceneNum, player);
            }
        }

        reaction(
            () => this.props.performanceState.scene,
            (currentScene) => {
                if (this.scenePlayers.has(currentScene)) {
                    this.stopAllPlayers(currentScene);
                    const currentPlayer = this.scenePlayers.get(currentScene);
                    const { performanceState } = this.props;

                    if (currentScene === 1) {
                        when(
                            () =>
                                performanceState.sceneMentionedUsers.get(1)?.size === performanceState.userLayout.size,
                            () => {
                                currentPlayer?.start();
                            }
                        );
                    } else {
                        currentPlayer?.start();
                    }
                }

                if (scenePrompts.get(currentScene)?.music === null) {
                    this.stopAllPlayers();
                }
            }
        );

        if (typeof window !== "undefined") {
            // this.frame = window.requestAnimationFrame(this.handleAnimationFrame);
        }
    }

    public componentWillUnmount() {
        if (typeof window !== "undefined" && this.frame !== undefined) {
            window.cancelAnimationFrame(this.frame);
        }
    }

    public render() {
        return null;
    }

    private stopAllPlayers = (except?: number) => {
        for (const [scene, player] of this.scenePlayers) {
            if (except === scene) {
                continue;
            }

            player.stop();
        }
    };

    private handleInitialScenePlayerLoaded = () => {
        const { scene } = this.props.performanceState;
        this.scenePlayers.get(scene)?.start();
    };

    private handleAnimationFrame = () => {
        this.frame = window.requestAnimationFrame(this.handleAnimationFrame);
    };
}
